import React from "react";
import { getLanguage, setLanguage, t } from "./index";
import { LANGUAGES } from "./languages";
import "./LanguageSwitcher.scss";

/** FR · EN · ع buttons. Picking a language reloads the page in it. */
export default function LanguageSwitcher({ className = "" }) {
  const current = getLanguage();
  return (
    <div className={`lng-switch ${className}`} role="group" aria-label={t("common:language")}>
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          lang={l.code}
          className={l.code === current ? "is-active" : undefined}
          aria-pressed={l.code === current}
          title={l.label}
          onClick={() => setLanguage(l.code)}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
}
